import "./ReviewSnackbar.scss";
import type {SnackbarCloseReason} from "@mui/material";
import {Alert, Snackbar} from "@mui/material";
import React from "react";
import {observer} from "mobx-react-lite";
import {reviewSnackbarController} from "./ReviewSnackbarController";

export const ReviewSnackbar: React.FC = observer(() => {
    const handleCloseSnackbar = (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
        if (reason === 'clickaway') {
            return;
        }
        reviewSnackbarController.hide()
    };
    return <Snackbar
        className="review-snackbar"
        open={reviewSnackbarController.snackBarVisible}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        onClose={handleCloseSnackbar}>
        <Alert
            onClose={handleCloseSnackbar}
            severity={reviewSnackbarController.snackBarContent?.severity ?? 'info'}
            sx={{width: '100%'}}>
            {reviewSnackbarController.snackBarContent?.msg ?? ''}
        </Alert>
    </Snackbar>
})
